import {
  FormDefaultAttributes,
  type DatePickerConfig,
  type FormConfig,
  type SmallerThanValidValidatorConfig
} from '@common';
import type { HeightmapDataPeriodDateValidatorConfig } from '../validators/heightmap-data-period-date.validator';
import { PeriodBoundary } from '../../../models';

export const HEIGHT_MAP_WIZARD_FORM_CONFIG: FormConfig = {
  name: 'heightmapWizardForm',
  attributes: {
    ...FormDefaultAttributes.getFormDefaultAttributes()
  },
  children: [
    {
      name: 'dateFrom',
      component: 'datepicker',
      attributes: {
        label: 'heightmap.label.fromDate',
        displayFormat: 'yyyy.MM.dd.',
        format: 'yyyy-MM-dd',
        clearable: true,
        closeCalendarOnPick: true,
        min: '2021-01-01',
        max: new Date()
      },
      settings: {
        needTranslate: true,
        grid: {
          cols: 12,
          md: 6
        },
        validation: {
          onBlur: true,
          onInput: true
        },
        hideGridSlotWhenInvisible: true
      },
      relatedElements: ['heightmapWizardForm.dateTo'],
      validators: [
        {
          validator: 'required'
        },
        {
          validator: 'smallerThan',
          settings: {
            otherFieldName: 'dateTo',
            invalidMessage: 'heightmap.form.validator.smallerThan.invalidMessage',
            needTranslate: true
          }
        } as SmallerThanValidValidatorConfig,
        {
          validator: 'heightmapDataPeriodDate',
          settings: {
            otherFieldName: 'dateTo',
            periodBoundary: PeriodBoundary.START,
            invalidStartDateMessage: 'heightmap.form.validator.heightmapDataPeriodDate.invalidStartDateMessage',
            needTranslate: true
          }
        } as HeightmapDataPeriodDateValidatorConfig
      ]
    } as DatePickerConfig,
    {
      name: 'dateTo',
      component: 'datepicker',
      attributes: {
        label: 'heightmap.label.toDate',
        displayFormat: 'yyyy.MM.dd.',
        format: 'yyyy-MM-dd',
        clearable: true,
        closeCalendarOnPick: true,
        min: '2021-01-08',
        max: new Date()
      },
      settings: {
        needTranslate: true,
        grid: {
          cols: 12,
          md: 6
        },
        validation: {
          onBlur: true,
          onInput: true,
          validateParent: true
        },
        hideGridSlotWhenInvisible: true
      },
      relatedElements: ['heightmapWizardForm.dateFrom'],
      validators: [
        {
          validator: 'required'
        },
        {
          validator: 'greaterThan',
          settings: {
            otherFieldName: 'dateFrom',
            invalidMessage: 'heightmap.form.validator.greaterThan.invalidMessage',
            needTranslate: true
          }
        },
        {
          validator: 'heightmapDataPeriodDate',
          settings: {
            otherFieldName: 'dateFrom',
            periodBoundary: PeriodBoundary.END,
            invalidEndDateMessage: 'heightmap.form.validator.heightmapDataPeriodDate.invalidEndDateMessage',
            needTranslate: true
          }
        } as HeightmapDataPeriodDateValidatorConfig
      ]
    } as DatePickerConfig
  ]
};
